import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { DataSourceType } from '@/modules/core/app/constants/datasource.constants';
import { DataSource } from '@/modules/core/datasource/models/DataSource';
import { isEmpty } from 'lodash';

export class DashboardFilterItem extends BaseModel {
  /**
   * @var {string}
   */
  field;

  /**
   * @var {string}
   */
  key;

  /**
   * @var {string}
   */
  format;

  /**
   * @var {string}
   */
  label;

  /**
   * @var {string}
   */
  association;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {array}
   */
  values;

  /**
   * @var {array}
   */
  globalFilter;

  /**
   * @var {boolean}
   */
  is_live_integration;

  /**
   * @var {DataSource}
   */
  data_source;

  /**
   * @var {string}
   */
  data_view_name;

  /**
   * @var {string}
   */
  id_name;

  constructor(model = {}) {
    super();
    // eslint-disable-next-line tap/no-raw-text-js
    this.field = model.field || 'id';
    this.key = model.key;
    // eslint-disable-next-line tap/no-raw-text-js
    this.format = model.format || 'id';
    this.label = model.label || null;
    // eslint-disable-next-line tap/no-raw-text-js
    this.association = model.association || 'and';
    // eslint-disable-next-line tap/no-raw-text-js
    this.type = model.type || 'in';
    this.values = model.values || [];
    this.globalFilter = model.globalFilter || [];
    this.is_live_integration = model.is_live_integration;
    this.data_source = !isEmpty(model.data_source) ? new DataSource(model.data_source) : null;
    this.data_view_name = model.data_view_name;
    this.id_name = model.id_name;
  }

  /**
   * @returns {boolean}
   */
  isClient() {
    return this.label === DataSourceType.CLIENT;
  }

  /**
   * @returns {boolean}
   */
  isClientGroup() {
    return this.label === DataSourceType.CLIENT_GROUP;
  }

  /**
   * @returns {boolean}
   */
  isCluster() {
    return this.label === DataSourceType.CLUSTER;
  }

  /**
   * @returns {boolean}
   */
  isSmartCampaign() {
    return this.label === DataSourceType.SMART_CAMPAIGN;
  }
}
